import { render, staticRenderFns } from "./RatingListItems.vue?vue&type=template&id=501bc0c7"
import script from "./RatingListItems.vue?vue&type=script&lang=js"
export * from "./RatingListItems.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports